import React from 'react';
// import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Theme } from '@mui/system';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Contacts from './Contacts';
import Socials from '../common/Socials';
import LanguageSelector from './LanguageSelector';
import Logo from '../../assets/logo.png';
// import TabsList from './TabsList';

export default function Header(): JSX.Element {
  // const { t } = useTranslation();

  return (
    <AppBar position="static">
      <Box
        sx={{
          overflowX: 'auto',
          overflowY: 'hidden',
          p: (theme: Theme) => `${theme.spacing(2)} 0`,
          pl: { xs: 1, sm: 0 },
          pr: { xs: 1, sm: 0 },
        }}
      >
        <Container maxWidth="xl" sx={{ minWidth: '320px' }}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12} sm="auto">
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: { xs: 'center', sm: 'auto' },
                  pt: { xs: 1, sm: 0 },
                }}
              >
                <Box component={Link} to="/" sx={{ textDecoration: 'none' }}>
                  <Box
                    component="img"
                    src={Logo}
                    alt="logo"
                    sx={{
                      width: { xs: 60 },
                      height: { xs: 60 },
                    }}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm>
              <Contacts />
            </Grid>
            <Grid item container sx={{ width: { xs: '100%', sm: 'auto' } }}>
              <Grid
                item
                sx={{
                  width: { xs: '100%', sm: 'auto' },
                  display: { xs: 'flex', sm: 'block' },
                  justifyContent: { xs: 'center', sm: 'initial' },
                }}
              >
                <Socials />
                <LanguageSelector />
              </Grid>
            </Grid>
          </Grid>
          <Typography variant="h6" align="center" color="red">
            {/* {t('header.workInUkraine')} */}
            Працюю по всій країнi
          </Typography>
          {/* <Box p={2} pb={1}> */}
          {/*  <TabsList /> */}
          {/* </Box> */}
        </Container>
      </Box>
    </AppBar>
  );
}
